import styled, { css } from 'styled-components';
import { LANDING_PLACEMENT } from 'src/commons/components/LandingAppIcon/LandingAppIcon';
import {
  IconButton,
  isDarkThemeMixin,
  styleMixinFocusOutline,
  styleMixinInvertedFocusOutline,
} from '@amzn/storm-ui';

const headerStyles = css`
  margin-inline-start: ${({ theme }) => theme.spacing.xxsmall.default};

  svg {
    font-size: 1rem;
  }

  &&& {
    color: ${({ theme }) => theme.icon.color.inverted};

    :hover,
    :active {
      background-color: ${({ theme }) => theme.color.gray[1000]};
    }

    :hover {
      color: ${({ theme }) => theme.icon.color.invertedHover};
    }

    :active {
      color: ${({ theme }) => theme.icon.color.invertedActive};
    }

    :focus-visible {
      ${styleMixinInvertedFocusOutline};
    }
  }

  ${isDarkThemeMixin(css`
    &&& {
      color: ${({ theme }) => theme.icon.color.default};

      :hover {
        color: ${({ theme }) => theme.icon.color.secondary};
      }

      :active {
        color: ${({ theme }) => theme.icon.color.tertiary};
      }

      :focus-visible {
        ${styleMixinFocusOutline};
      }
    }
  `)};
`;

const sidenavStyles = css`
  width: 40px;
  height: 40px;
  border-radius: ${({ theme }) => theme.border.radius.medium};
  margin-inline-start: ${({ theme }) => theme.spacing.xxxxsmall.default};

  &&& {
    color: ${({ theme }) => theme.icon.color.default};

    :hover {
      color: ${({ theme }) => theme.icon.color.secondary};
    }
  }
`;

export const LandingAppIconButton = styled(IconButton)<{
  placement: LANDING_PLACEMENT;
}>`
  ${({ placement }) =>
    placement === LANDING_PLACEMENT.HEADER ? headerStyles : sidenavStyles};
`;
